

/* tslint:disable */




import { FlowchartNodeDto } from './FlowchartNodeDto';

export class FlowchartComponentDto extends FlowchartNodeDto {

}

